// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconRefreshPath = 'M16.36 3.99a3.64 3.64 0 0 1 3.207 1.897 3.512 3.512 0 0 1-.146 3.64l-2.67 3.345-1.563-1.25 2.614-3.265c.265-.416.288-.998.007-1.516a1.62 1.62 0 0 0-1.449-.851H9.137l1.634 1.96-1.537 1.28-3-3.6a1 1 0 0 1 0-1.28l3-3.6 1.537 1.28-1.634 1.96h7.223Zm-7.133 8.072 1.536-1.28 3 3.6a1 1 0 0 1 0 1.28l-3 3.6-1.536-1.28 1.633-1.96H3.644a3.638 3.638 0 0 1-3.205-1.896 3.514 3.514 0 0 1 .146-3.641L3.254 7.14l1.562 1.249-2.612 3.266c-.265.416-.29.999-.007 1.518.289.531.83.849 1.447.849h7.216l-1.633-1.96Z';
var IconRefresh = baseIcon('IconRefresh', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconRefreshPath
});
export default IconRefresh;
//# sourceMappingURL=index.js.map